module.exports = __webpack_public_path__ + "static/media/50_states_50_ideas.3b33a1ea.jpg";